
// Generated by dayjs-nuxt-module
import dayjs from 'dayjs'
import updateLocale from 'dayjs/plugin/updateLocale'

import 'dayjs/locale/nb'
import duration from 'dayjs/plugin/duration'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import localeData from 'dayjs/plugin/localeData'
import isBetween from 'dayjs/plugin/isBetween'
import timezone from 'dayjs/plugin/timezone'
import relativeTime from 'dayjs/plugin/relativeTime'
import utc from 'dayjs/plugin/utc'


dayjs.extend(updateLocale)

dayjs.extend(duration)
dayjs.extend(customParseFormat)
dayjs.extend(localeData)
dayjs.extend(isBetween)
dayjs.extend(timezone)
dayjs.extend(relativeTime)
dayjs.extend(utc)



// defaultLocale: ["nb",{"name":"nb","weekdays":["søndag","mandag","tirsdag","onsdag","torsdag","fredag","lørdag"],"weekdaysShort":["sø.","ma.","ti.","on.","to.","fr.","lø."],"weekdaysMin":["sø","ma","ti","on","to","fr","lø"],"months":["januar","februar","mars","april","mai","juni","juli","august","september","oktober","november","desember"],"monthsShort":["jan.","feb.","mars","april","mai","juni","juli","aug.","sep.","okt.","nov.","des."],"weekStart":1,"yearStart":4,"formats":{"LT":"HH:mm","LTS":"HH:mm:ss","L":"DD.MM.YYYY","LL":"D. MMMM YYYY","LLL":"D. MMMM YYYY [kl.] HH:mm","LLLL":"dddd D. MMMM YYYY [kl.] HH:mm"},"relativeTime":{"future":"om %s","past":"%s siden","s":"noen sekunder","m":"ett minutt","mm":"%d minutter","h":"en time","hh":"%d timer","d":"en dag","dd":"%d dager","M":"en måned","MM":"%d måneder","y":"ett år","yy":"%d år"}}]


dayjs.updateLocale("nb",{"name":"nb","weekdays":["søndag","mandag","tirsdag","onsdag","torsdag","fredag","lørdag"],"weekdaysShort":["sø.","ma.","ti.","on.","to.","fr.","lø."],"weekdaysMin":["sø","ma","ti","on","to","fr","lø"],"months":["januar","februar","mars","april","mai","juni","juli","august","september","oktober","november","desember"],"monthsShort":["jan.","feb.","mars","april","mai","juni","juli","aug.","sep.","okt.","nov.","des."],"weekStart":1,"yearStart":4,"formats":{"LT":"HH:mm","LTS":"HH:mm:ss","L":"DD.MM.YYYY","LL":"D. MMMM YYYY","LLL":"D. MMMM YYYY [kl.] HH:mm","LLLL":"dddd D. MMMM YYYY [kl.] HH:mm"},"relativeTime":{"future":"om %s","past":"%s siden","s":"noen sekunder","m":"ett minutt","mm":"%d minutter","h":"en time","hh":"%d timer","d":"en dag","dd":"%d dager","M":"en måned","MM":"%d måneder","y":"ett år","yy":"%d år"}})
dayjs.locale('nb')


export default dayjs
